import React, { useEffect, useState } from 'react'

export const LogoInput = ({ logoUrl, setLogoUrl }) => {
    const [active, setActive] = useState(false);
    const onElemFocus = (e) => {
        e.target.parentElement.classList.add("focusWithText");
    };

    const onElemBlur = (e) => {
        if (e.target.value === "") {
            e.target.parentElement.classList.remove("focusWithText");
        }
    };
    useEffect(() => {
        let fieldHTML = document.getElementById('add_logoUrl');
        if (fieldHTML){
            fieldHTML.addEventListener('focus', onElemFocus);
            fieldHTML.addEventListener('blur', onElemBlur);
        }
     

        return () => {
            if (fieldHTML){
                fieldHTML.removeEventListener('focus', onElemFocus);
                fieldHTML.removeEventListener('blur', onElemBlur);
            }

            }

        
    }, [active]);
    return (
        !active?(
            <div
                className='company-logo big cursor'
                style={
                    {
                        backgroundImage: `url(${logoUrl || 'https://t3.ftcdn.net/jpg/01/87/10/40/360_F_187104027_8i2JbFDBB5jB7R65Ce464yRs4gfNbR3Z.jpg'})`,
                    }
                }
                onClick={() => { setActive(true) }}
            />
        ):(
            
            <div className="inputGroup inputGroup2 focusWithText">
                        <input type="text" id="add_logoUrl" name='logoUrl' value={logoUrl} onChange={(e) => { setLogoUrl(e.target.value) }} autoComplete="off" />
                        <p className="helper helper1">Add a company image url</p>
                    </div>
        )

    )
}
